import { createSignal } from "solid-js";
import { closeAllModals, openModalV2 } from "~/shared_states/modal";
import {
  AxisUserInfoModal,
  ProfileUpdateParams,
} from "../fragments/axis_user_info_modal";

export type OpenAxisUserInfoModalProps = {
  email: string | null;
  phone: string | null;
  name: string | null;
  redemptionAmount: number;
  brandName: string;
  brandLogoUrl: string;
  onSubmit: (profileUpdateParams: ProfileUpdateParams) => Promise<void>;
};

export default function useAxisUserInfoModal() {
  const [showLoader, setShowLoader] = createSignal<boolean>(false);
  const [errors, setErrors] = createSignal<{ [key: string]: string }>({});

  const openModal = (props: OpenAxisUserInfoModalProps) => {
    setShowLoader(false);
    setErrors({});
    openModalV2(() => {
      return (
        <AxisUserInfoModal
          email={props.email}
          phone={props.phone}
          name={props.name}
          redemptionAmount={props.redemptionAmount}
          brandName={props.brandName}
          brandLogoUrl={props.brandLogoUrl}
          onSubmit={props.onSubmit}
          showLoader={showLoader}
          setShowLoader={setShowLoader}
          errors={errors}
          setErrors={setErrors}
          onClose={() => closeModal()}
        />
      );
    });
  };

  async function closeModal() {
    await closeAllModals();
    setShowLoader(false);
    setErrors({});
  }

  return {
    openModal,
    showLoader,
    setShowLoader,
    closeModal,
  };
}
